export default import.meta.ROLLDOWN_FILE_URL_QAW11aQ9TuLzHd_oKG5$Vg